__turbopack_context__.v({
  "editor": "plan-editor-module__I6VueG__editor",
  "fields": "plan-editor-module__I6VueG__fields",
  "layout": "plan-editor-module__I6VueG__layout",
  "mobileNavigation": "plan-editor-module__I6VueG__mobileNavigation",
  "navigation": "plan-editor-module__I6VueG__navigation",
  "summary": "plan-editor-module__I6VueG__summary",
});
